import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const API = process.env.REACT_APP_LAMBDA_ARTEH_API_DOMAIN;

/**
 * The caller's role in the active company (owner/admin/member/assurer),
 * from /api/user/companies. Fetched once per page load and shared.
 */
let rolesPromise: Promise<Record<string, string>> | null = null;

export function useCompanyRole(): string | null {
	const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
	const [role, setRole] = useState<string | null>(null);
	const activeCompanyId =
		user?.["https://arteh.com.au/user_metadata"]?.activeCompanyId;

	useEffect(() => {
		if (!isAuthenticated || !activeCompanyId) return;
		if (!rolesPromise) {
			rolesPromise = (async () => {
				const token = await getAccessTokenSilently();
				const res = await fetch(`${API}/api/user/companies`, {
					headers: { Authorization: `Bearer ${token}` },
				});
				const json = await res.json().catch(() => ({}));
				const map: Record<string, string> = {};
				for (const c of json?.Data?.companies || [])
					if (c?.id != null && c?.role) map[String(c.id)] = c.role;
				return map;
			})().catch(() => {
				rolesPromise = null;
				return {};
			});
		}
		let cancelled = false;
		rolesPromise.then((map) => {
			if (!cancelled) setRole(map[String(activeCompanyId)] ?? null);
		});
		return () => {
			cancelled = true;
		};
	}, [isAuthenticated, activeCompanyId, getAccessTokenSilently]);

	return role;
}
